
import { OmnisoftCheckData } from '../common/omnisoft-check-data';
export class OmnisoftLoginRequestData {
  checkData: OmnisoftCheckData;
  name: string;
  password: string;
}
